export {
  ITEM_TYPES,
  PAYLOAD_LIMITS,
  daysUntilExpiry,
  emptyPayload,
  fieldLabels,
  isAutofillable,
  isItemType,
  isVaultPayload,
  itemTypeLabel,
  parsePayload,
  serializePayload,
  validatePayload
} from "@passwordflow/crypto";
export type { CustomField, FieldLabels, ItemType, PasskeyCredential, VaultPayload } from "@passwordflow/crypto";

/** AAD used before item ids were bound into the ciphertext. Read-only fallback; edits re-encrypt with item-v2. */
export const LEGACY_VAULT_AAD = "passwordflow/vault-v1";
